export enum DisputeReasonEnum {
    All = 0,
    MissingItem = 1,
    WrongItem = 2,
    LatePickup = 3,
    NoFulfilment = 4,
    Other = 5
}
